import apiClient from '@u/apiClient'
import AddItemsToInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/AddItemsToInvoiceController'
import AddItemDossierToInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/AddItemDossierToInvoiceController'
import AddInvoiceItemToDossierController from '@/wayfinder/actions/App/Http/Controllers/Invoice/AddInvoiceItemToDossierController'
import AddItemDossiersToInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/AddItemDossiersToInvoiceController'
import GetItemsFromAutomationController from '@/wayfinder/actions/App/Http/Controllers/Invoice/GetItemsFromAutomationController'
import GetItemsDossierController from '@/wayfinder/actions/App/Http/Controllers/Invoice/GetItemsDossierController'
import AddPacksToInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/AddPacksToInvoiceController'
import UpdateInvoiceItemVisibilityController from '@/wayfinder/actions/App/Http/Controllers/InvoiceItem/UpdateInvoiceItemVisibilityController'
import UpdateInvoiceItemController from '@/wayfinder/actions/App/Http/Controllers/InvoiceItem/UpdateInvoiceItemController'
import DeleteInvoiceItemController from '@/wayfinder/actions/App/Http/Controllers/InvoiceItem/DeleteInvoiceItemController'
import ReorderInvoiceItemsController from '@/wayfinder/actions/App/Http/Controllers/Invoice/ReorderInvoiceItemsController'

// import router from "@/router";

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // region fetch
  async fetchInvoiceItemID({ commit }, payload) {
    await apiClient
      .get(`/api/invoicing/invoice-item/${payload.id}`)
      .then(async (response) => {
        await commit('setInvoiceItem', response.data.invoice_item)
        commit('auth/setErrors', {}, { root: true })
      })
      .catch((reason) => {
        console.error('fetchInvoiceItemID reason', reason)
      })
  },
  // endregion

  // region store
  async storeInvoiceItem({ commit }, payload) {
    await apiClient
      .put(`/api/invoicing/add-item-fast/${payload.invoiceId}`, {
        item_id: payload.item_id
      })
      .then(async (response) => {
        await commit('setInvoice', response.data.invoice)
        await commit('setInvoiceMetadata', response.data.metadata)
      })
      .catch((reason) => {
        console.error('storeInvoiceItem reason', reason)
      })
  },
  // endregion

  // region update
  addItemsToInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddItemsToInvoiceController.post({ invoice: payload.invoice_id }),
          payload.data
        )
        .then(async (response) => {
          if (response.status === 200) {
            await commit('setInvoice', response.data.invoice)
            await commit('setInvoiceMetadata', response.data.metadata)
            processSuccessCallback(payload)
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  addItemDossierToInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddItemDossierToInvoiceController.post({
            invoice: payload.invoice_id
          }),
          payload.data
        )
        .then(async (response) => {
          await commit('setInvoice', response.data.invoice)
          await commit('setInvoiceMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  addInvoiceItemToDossier: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddInvoiceItemToDossierController.post({
            invoice_item: payload.invoice_item_id
          })
        )
        .then(async (response) => {
          if (response.status === 200) {
            await commit('setInvoice', response.data.invoice)
            await commit('setInvoiceMetadata', response.data.metadata)
            processSuccessCallback(payload)
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  addItemDossiersToInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddItemDossiersToInvoiceController.post({
            invoice: payload.invoice_id
          }),
          payload.data
        )
        .then(async (response) => {
          if (response.status === 200) {
            await commit('setInvoice', response.data.invoice)
            await commit('setInvoiceMetadata', response.data.metadata)
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchAutomationsItems: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetItemsFromAutomationController.get({ invoice: payload.invoice_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchDossierItems: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemsDossierController.get({ invoice: payload.invoice_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async addPackToInvoice({ commit }, payload) {
    await apiClient
      .route(
        AddPacksToInvoiceController.post({ invoice: payload.invoice_id }),
        payload.data
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setInvoice', response.data.invoice)
          await commit('setInvoiceMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },
  // ci dessous devrait disparaitre
  async updateInvoiceItem({ commit }, payload) {
    await apiClient
      .put(
        `/api/invoicing/add-item-fast/${payload.invoice_id}`,
        payload.content
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setInvoice', response.data.invoice)
          await commit('setInvoiceMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },
  // ci dessous devrait disparaitre
  async updateInvoiceDossierItem({ commit }, payload) {
    await apiClient
      .put(`/api/invoicing/add-item-fast/${payload.invoice_id}`, {
        dossier_id: payload.dossier_id,
        item_dossier_id: payload.dossier_item_id
      })
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setInvoice', response.data.invoice)
          await commit('setInvoiceMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },
  // ci dessous devrait disparaitre
  async updateMultipleInvoiceItems({ commit }, payload) {
    await apiClient
      .put(
        `/api/invoicing/add-multiple-items/${payload.invoice_id}`,
        payload.items
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setInvoice', response.data.invoice)
          await commit('setInvoiceMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },

  updateInvoiceItemVisibility: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateInvoiceItemVisibilityController.patch({
            invoice: payload.invoice_id,
            invoice_item: payload.id
          }),
          { hide_on_inline_invoice: payload.hide_on_inline_invoice }
        )
        .then((response) => {
          commit('setInvoice', response.data.invoice)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateSingleInvoiceItem: ({ commit }, payload) => {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateInvoiceItemController.put({
            invoice: payload.invoice_id,
            invoice_item: payload.id
          }),
          payload.invoice_item,
          {
            params: {
              for_invoice: payload.for_invoice
            }
          }
        )
        .then((response) => {
          if (payload.for_invoice) {
            commit('setInvoice', response.data.invoice)
          } else {
            commit('setInvoiceItemIndex', response.data.invoice_items)
            commit('setInvoiceItemsMetadata', response.data.metadata)
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // async updateMultipleInvoiceItems({ commit }, payload) {
  //   await apiClient
  //     .put(
  //       `api/invoicing/add-multiple-items/${payload.invoiceId}`,
  //       payload.items
  //     )
  //     .then(async (response) => {
  //       await commit('setInvoice', response.data.invoice)
  //       if (payload.successCallback) {
  //         payload.successCallback()
  //       }
  //     })
  //     .catch(async (reason) => {
  //       console.error('putMultipleInvoiceItems reason', reason)
  //     })
  // },
  // endregion

  // region delete
  async deleteInvoiceItem({ commit }, payload) {
    await apiClient
      .route(
        DeleteInvoiceItemController.delete.delete({
          invoice: payload.invoice_id,
          invoice_item: payload.id
        })
      )
      .then(async (response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
        }
        if (payload.supplier_order_index === null) {
          await commit('setInvoiceMetadata', response.data.metadata)
          await commit('setInvoice', response.data.invoice)
        } else {
          await commit('setInvoiceAtIndex', {
            index: payload.supplier_order_index,
            invoice: response.data.invoice
          })
        }
      })
      .catch(async (reason) => {
        console.error('deleteInvoiceById reason', reason)
      })
  },
  async undoDeleteInvoiceItem({ commit }, payload) {
    await apiClient
      .route(
        DeleteInvoiceItemController.undo.get({
          invoice: payload.invoice_id,
          id: payload.id
        })
      )
      .then(async (response) => {
        if (payload.successCallback) {
          payload.successCallback()
        }
        if (payload.supplier_order_index === null) {
          await commit('setInvoiceMetadata', response.data.metadata)
          await commit('setInvoice', response.data.invoice)
        } else {
          await commit('setInvoiceAtIndex', {
            index: payload.supplier_order_index,
            invoice: response.data.invoice
          })
        }
      })
      .catch(async (reason) => {
        console.error('undoDeleteMessageTextById', reason)
      })
  },
  // endregion
  // region order invoice items
  async reorderInvoiceItems({ commit }, payload) {
    // mutation dans le state local pour éviter l'effet de clipping dnas la facture
    await commit('reorderInvoiceItems', payload)
    apiClient
      .route(
        ReorderInvoiceItemsController.put({
          invoice: payload.invoice_id,
          invoice_item: payload.id
        }),
        payload.data
      )
      .then(async (response) => {
        if (response.status === 200) {
          commit('setInvoice', response.data.invoice)
          await commit('setInvoiceMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error(reason)
      })
  }
  // endregion
}
